import _ from 'underscore';

export default class OfferSectionMenu {
  constructor($scope) {
    $scope.menu = [
      {
        title: 'Main Details',
        action: 'edit_overview',
        pages: [
          'edit_overview',
          'edit_main_title',
          'edit_main_basic',
          'edit_main_description',
          'edit_main_stocklist',
          'edit_main_connections',
          'edit_sections_tags',
          'edit_sections_specs',
          'edit_sections_images',
          'edit_sections_offers',
          'edit_market'
        ]
      },
      {
        title: 'Prices & Charges',
        action: 'edit_prices',
        pages: [
          'edit_prices',
          'edit_ospp_users',
          'edit_user_pricing',
          'edit_supplier_pricing'
        ]
      },
      {
        title: 'Matching',
        action: 'edit_matching',
        pages: [
          'edit_matching'
        ]
      },
      {
        title: 'Advanced',
        action: 'edit_faq',
        pages: [
          'edit_faq',
          'edit_themes',
          'edit_requests',
          'edit_orders',
          'edit_reports',
          'edit_notes'
        ]
      },
      {
        title: 'Campaigns',
        action: 'edit_campaigns',
        pages: [
          'edit_campaigns'
        ]
      },
      {
        title: 'Create General',
        action: 'edit_create_inventory',
        pages: []
      },
      {
        title: 'Create Personal',
        action: 'edit_create_personalized_offer',
        pages: []
      },
      {
        title: 'Copy',
        action: 'copy_offer',
        pages: []
      }
    ];

    $scope.init = function() {
      $scope._ = _;
    };

    $scope.init();
  }
}

OfferSectionMenu.$inject = ['$scope'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-section-menu.ctrl.js